import { useEffect } from "react";
import { useParams, Link } from "react-router-dom"; 
import { useForm, Controller } from "react-hook-form";
import { selectCurrentUser } from "context/auth/authSlice";
import { selectCurrentPage } from "context/pages/pageSlice";
import { useMaterialUIController } from "context";
import { useSelector } from "react-redux";
import useCart from "hooks/useCart";

import DOMPurify from 'isomorphic-dompurify';
import parse from 'html-react-parser';

import {  useGetProductByIdQuery } from 'context/product/productApiSlice';
import {  Grid, Card, Container, Chip, Icon, Divider, ButtonGroup } from "@mui/material";

import MDTypography from "dashboard/components/MDTypography";
import MDButton from "dashboard/components/MDButton";
import MDBox from "dashboard/components/MDBox";
import MDInput from "dashboard/components/MDInput";
import MDCarousel from "dashboard/components/MDCarousel";
import MDAccordion from "dashboard/components/MDAccordion";

import Ratings from "components/Home/products/components/Ratings";

// import EcommerceAttr from "dashboard/examples/Forms/CostumFormFields/EcommerceAttr"
import Navigation  from "components/Home/components/navigation";
import CostEstimator from "components/Home/products/components/CostEstimator";
import ProductDetailsTable from "components/Home/products/sections/ProductDetailsTable";
// Images
import bgImage from "assets/images/bg-profile.jpeg";
import LandingFooter from "components/Home/components/landingFooter";
import Commentbox from "components/Home/products/sections/Reviews"
import MDAlert from "dashboard/components/MDAlert";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTube from '@mui/icons-material/YouTube';

const parseContent = content => parse(DOMPurify?.sanitize(content));
const  limitTextToWords = (text, maxWords = 100)=>{
  if(typeof text !== "string" ) return "...";
  // Split the text into an array of words
  const words = text.split(' ');

  // If the number of words is less than or equal to the limit, return the original text
  if (words.length <= maxWords) {
    return text;
  }

  // Otherwise, slice the array to get the first 'maxWords' words and join them back into a string
  const limitedText = words.slice(0, maxWords).join(' ');

  // Add an ellipsis (...) to indicate that the text has been truncated
  return limitedText + '...';
}

const ProductPage = () => {
  const [ controller ] = useMaterialUIController();
  const { darkMode } = controller;
  const pageContent = useSelector(selectCurrentPage);
  const {id} = useParams();
  const { cart, addItem } = useCart();
  const connectedUser = useSelector(selectCurrentUser);
  const { data : product } = useGetProductByIdQuery(id);
  const initialValues = {
    id : null,
    details: {
      dimensions: {
          length: 0,
          width : 0,
          height: 0
      },
      sizes: [],
      weight: 0
    },
    colors:[],
    quantity:0
}
  const { register, handleSubmit, control, setValue, reset, getValues, formState: { errors } } = useForm({ // setValue,
    /* eslint-disable */
    defaultValues: initialValues
  });

  useEffect(() => {
    if(!Boolean(cart.items.find(item=>item.id === id))) return ;
    reset(cart.items.find(item=>item.id === id))
  }, [cart])

  const onSubmit = data => {
    data.id = product.id;
    data.productName = product.productName;
    data.price = product.price.sold !== 0 ? product.price.sold : product.price.original ;
    addItem(data)
  };
  
  return (
    <>
      {pageContent.Navigation?.navBar && <Navigation parseContent={parseContent} data={{ navBar : pageContent.Navigation?.navBar, logo : pageContent.Navigation.logo?.selectedImage, menu: pageContent.Menu }}  />}
        <MDBox
            minHeight={{xs:"20vh" , lg: "55vh"}}
            width="100%"
            sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
                )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
            marginTop : 28.5
            }}
        > 
            <Container maxWidth="sm">
            <Grid
                container
                item
                xs={12}
                lg={8}
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                sx={{ mx: "auto", textAlign: "center" }}
            >
                <MDButton component={Link} to="/authentication/sign-up" sx={{ color: ({ palette: { dark } }) => dark.main }}>
                créer un compte
                </MDButton>
                <MDTypography variant="h6" color="white" mt={3} mb={1}>
                Trouvez-nous sur
                </MDTypography>
                <MDBox display="flex" justifyContent="center" alignItems="center">
                <MDTypography component="a" variant="body1" color="white" href={pageContent.Contact?.facebook} mr={3}>
                    <FacebookIcon />
                </MDTypography>
                <MDTypography component="a" variant="body1" color="white" href={pageContent.Contact?.twitter} mr={3}>
                  <TwitterIcon />
                </MDTypography>
                <MDTypography component="a" variant="body1" color="white" href={pageContent.Contact?.instagram} mr={3}>
                  <InstagramIcon />
                </MDTypography>
                </MDBox>
            </Grid>
            </Container>
        </MDBox>
        <Card
            sx={{
            p: { xs: 1, lg: 2 },
            mx: { xs: 1, lg: 3 },
            mt: -8,
            mb: 4,
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
            >
            <Container sx={{my:4, px:{sx:0, lg:2}}}>
              {product && <Grid container spacing={{sx:1,lg:4}} justifyContent="center" mx="auto">
                <Grid item xs={12} md={6} lg={6} sx={{minHeight: "300px",mb: {xs:4,lg:1}}}>
                      {product.photos &&  product.photos.length !== 0 ? <MDCarousel items={product.photos} zoom color='grey' thumbnail /> : (
                        <MDAlert color="info" size="sm">La list des photos est vide</MDAlert>
                      )}
                </Grid> 
                <Grid item xs={12} md={6} lg={6} sx={{ display: "flex" }}>
                  <Divider orientation="vertical" sx={{ ml: -2, mr: 3, height:"100%", display:{xs : "none", lg : "block"} }} />
                  <MDBox sx={{width:"100%"}}>
                      <MDTypography color="primary" variant="h4">{product.productName}</MDTypography>
                      <MDTypography color="text" variant="body2">{product.category?.name}</MDTypography>
                      <MDBox display='flex' justifyContent="space-between" >
                        <MDTypography  color="text" variant="div"><MDTypography sx={{display:"inline-block"}} color="text" variant="body2">Disponibilité  </MDTypography>
                        <Chip
                          label={product.inStock ? "En stock" : "En rupture de stock"}
                          color={product.inStock ? "primary" : "default"}
                          sx={{px:1, mx:1}}
                          deleteIcon={<Icon fontSize="md">{product.inStock ? "done" : "warning"}</Icon>} onDelete={()=>{}}
                        /></MDTypography>
                      </MDBox>
                        <MDBox sx={{my:2}}>
                          <MDAccordion color="light">
                            <MDBox component="div">
                              <MDTypography  variant="h5">Description</MDTypography>
                              <MDTypography component='div' color="text" variant="body2">{parse(DOMPurify.sanitize(product.description))}</MDTypography>
                            </MDBox>
                            <MDBox  component="div">
                              <MDTypography  variant="h5">Applications</MDTypography>
                              <MDTypography component='div' color="text" variant="body2">{parse(DOMPurify.sanitize(product.application))}</MDTypography>
                            </MDBox>
                            <MDBox  component="div">
                              <MDTypography  variant="h5">Autres caractéristiques</MDTypography>
                              {product.details && !product.details?.find(item=>item.label === null || item.label === "" )  ? <ProductDetailsTable DOMPurify={DOMPurify} parse={parse} details={product.details} /> : null}
                            </MDBox>
                            <MDBox component="div">
                              <MDTypography  variant="h5">Estimation de couts</MDTypography>
                              {product.estimate.length  ? <MDBox>
                                <CostEstimator setValue={setValue} expression={product.calculate?.trim()} price={product.price.sold !== 0 ? product.price.sold : product.price.original} userEnter={product.estimate} />
                              </MDBox>:  <MDAlert color="info" size="small">Le formulaire d'estimation de devis n'est pas encore mis en ligne</MDAlert> }
                            </MDBox>
                          </MDAccordion>
                          <Divider/>
                          <MDBox >
                            {(product.sheetURL && product.sheetURL !=="") && <MDBox >
                              {connectedUser ? (
                                <MDButton target="_blank" href={`${process.env.REACT_APP_PUBLIC_URL}/sheets/${product.sheetURL}`} size="medium"  sx={{ mr: 1, mt:2}}  variant="gradient" color="info" >
                                <Icon sx={{mr:1}} fontSize="lg">download</Icon>
                                télécharger la fiche technique
                              </MDButton>
                              ) : <MDBox sx={{display:"flex", alignItems:"center"}}><Icon sx={{mr:1}} fontSize="lg">info</Icon> <MDTypography variant="h6"> Connctez vous pour pouvoir télécharger la fiche technique</MDTypography>
                                  <MDButton size="small" sx={{mx:.5, px:1}} variant="gradient" color="secondary" component={Link} to="/authentication/sign-in" ><Icon sx={{mr:1}} fontSize="small">login</Icon>  ici</MDButton> 
                              </MDBox>}
                            </MDBox>}
                          </MDBox>
                        </MDBox>
                      <Divider sx={{width : "100%"}} />
                      <MDBox component="form" sx={{ whiteSpace: "normal" }} role="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="on">
                        {/* <EcommerceAttr product={{colors:getValues('colors'), details:{sizes:getValues('details.sizes')}}} register={register} control={control}  /> */}
                        <MDBox my={2}>
                          <ButtonGroup
                            disableElevation
                            aria-label="Disabled elevation buttons"
                          >
                          <MDButton onClick={()=>Number(getValues("quantity")) > 0 ? setValue('quantity',Number(getValues("quantity"))-1) :null} disableElevation size="medium" sx={{p:1}} variant="gradient" color="secondary">
                            <Icon sx={{mx:"auto"}} fontSize="lg">remove</Icon>
                          </MDButton>
                          <Controller name="quantity" control={control} 
                              render={({ field: { onChange, value } }) => (
                              <MDInput   onChange={onChange}   value={value} type="text" required 
                              {...register("quantity", { required: "missed", validate: value => value !== 0 })}
                              error={Boolean(errors.quantity)}
                              size="small"
                              className="quantity-details"
                              fullWidth
                              />
                              )}
                          />
                          <MDButton onClick={()=>setValue('quantity',Number(getValues("quantity"))+1)} disableElevation sx={{p:1}} size="medium" variant="gradient" color="secondary">
                            <Icon sx={{mx:"auto"}} fontSize="lg">add</Icon>
                          </MDButton>
                          </ButtonGroup>
                        </MDBox>
                        <MDButton size="medium"  sx={{ mr: 1, mt:2}}  variant="gradient" color="info" type="submit" >
                          <Icon sx={{mr:1}} fontSize="lg">shopping_cart_checkout</Icon>
                          Ajouter au panier
                        </MDButton>
                      </MDBox>
                  </MDBox>
                </Grid>
              </Grid>}
            </Container>
            <Divider sx={{width :"100%"}}/>
            <MDBox className="primary-accordian" style={{ marginBottom: "24px" }}>
               {product && <Commentbox alreadyRated={product.alreadyVoted}  connectedUser={connectedUser}  productID={id} darkMode={darkMode}/>}
            </MDBox>
        </Card>
        {pageContent.Contact && <LandingFooter data={pageContent.Contact} feed={pageContent.Features} limitTextToWords={limitTextToWords} about={pageContent.About} navBar={pageContent.Navigation?.navBar} logo={pageContent.Navigation.logo?.selectedImage} parseContent={parseContent}/>}
    </>
  );
};

export default ProductPage;